import { Input, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ExtendedParkingRangerSessionDTO, ParkingRangerSessionDTO } from 'src/app/base/models/models.swagger.generated';
import { ClientService } from 'src/app/base/services/client/client.service';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { GridModule } from '@syncfusion/ej2-angular-grids';

@Component({
    selector: 'app-parking-ranger-session-details-list',
    templateUrl: './parking-ranger-session-details-list.component.html',
    styleUrls: ['./parking-ranger-session-details-list.component.scss'],
    imports: [
        GridModule,
        TranslateModule,
    ]
})
export class ParkingRangerSessionDetailsListComponent extends GridBaseComponent implements OnInit {

  @Input()
  public set sessionData(sessionData: ExtendedParkingRangerSessionDTO) {
    this.selectedSession = sessionData;
  }

  public selectedSession: ExtendedParkingRangerSessionDTO;

  constructor(
    translateService: TranslateService,
    clientService: ClientService,
    private spinnerService: SpinnerService,
  ) {
    super(clientService, translateService, clientService);
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.clientService, this.spinnerService),
    });
  }

  protected initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any) {
    throw new Error('Method not implemented.');
  }
}
